<template>
  <Card
    displayControls
    notifications
    title="Product Image Upload"
    pathTo
    :location="goBackAndClearLastRoute"
  >
    <ValidationObserver
      class="d-flex flex flex-column justify-space-between"
      ref="observer"
      v-slot="{ changed }"
    >
      <v-card flat class="px-7 pt-7">
        <h1 class="midnightGreen--text">
          Product Image
          <br />Upload
        </h1>
        <div class="pt-16 d-flex flex  justify-center">
          <ImageInput
            image
            imageSize="220"
            iconSize="150"
            iconPosition="top: 9rem; left: 12rem;"
            edgeIconSize="100"
          />
        </div>
      </v-card>
      <BaseButton
        @click.native="submitProduct"
        :invalid="isImageSelected(changed)"
        :loading="buttonLoading"
        buttonColor="blueGreen"
        textColor="white"
        >Submit</BaseButton
      >
    </ValidationObserver>
  </Card>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";

import BaseButton from "@/components/BaseButton";
import Card from "@/components/Card";
import ImageInput from "@/components/ImageInput";
import { clearLastRouteMixin } from "@/mixins/clearLastRouteMixin";
import { checkRedirectRouteMixin } from "@/mixins/checkRedirectRouteMixin";

export default {
  name: "ProductImageUpload",
  mixins: [clearLastRouteMixin, checkRedirectRouteMixin],
  props: {
    redirectToRoute: String
  },
  components: {
    BaseButton,
    Card,
    ImageInput
  },
  created() {
    this.checkRedirectRoute();
  },
  computed: {
    ...mapState(["previewImage", "next", "redirectRoute", "buttonLoading"]),
    ...mapGetters(["isNext"])
  },
  methods: {
    ...mapActions(["uploadFiles"]),
    ...mapMutations([
      "setNextToFalse",
      "setRedirectRoute",
      "filterRedirectRoute",
      "setButtonLoading",
      "setButtonLoaded"
    ]),
    isImageSelected(changed) {
      if (this.previewImage) {
        return false;
      }

      if (changed) {
        return false;
      }

      return true;
    },
    async submitProduct() {
      this.setButtonLoading();

      await this.uploadFiles({
        id: this.$route.params.id,
        category: "product",
        next: true
      });

      this.setButtonLoaded();

      if (this.isNext) {
        const redirectToRoute = await this.extractRedirectRouteAndFilterSavedReference();

        this.$router.push({
          name: "ProductImagesView",
          params: {
            id: this.$route.params.id,
            redirectToRoute
          },
          query: {
            company: this.$route.query.company
          }
        });
        this.setNextToFalse();
      }
    }
  }
};
</script>
